import React, { useContext } from 'react';

import { DesktopScreen, MobileTabletScreen, StaticContext } from '@sm/webassets';
import { defineMessages, T } from '@sm/intl';
import { getClientEnvironmentDetails } from '@sm/utils';

import AppDirNavHeaderDesktop from './AppDirNavHeaderDesktop';
import AppDirNavHeaderMobile from './AppDirNavHeaderMobile';

import './app-dir-nav-header.scss';

export const COPY = defineMessages({
  NAV_EXPLORE: {
    id: 'AppsDirectory.AppDirNavHeader.ExploreLink',
    defaultMessage: 'Explore',
    description:
      '[Type: Link][Vis.: High] - A link that will direct the user to initial page of the app directory site',
  },
  NAV_MANAGE: {
    id: 'AppsDirectory.AppDirNavHeader.ManageLink',
    defaultMessage: 'Manage',
    description:
      '[Type: Link][Vis.: High] - A link that will direct the user their installed apps and will be able to manage them',
  },
  NAV_DEVELOP: {
    id: 'AppsDirectory.AppDirNavHeader.DevelopLink',
    defaultMessage: 'Develop',
    description: '[Type: Link][Vis.: High] - A link that will direct the user to the developer portal',
  },
  NAV_PARTNER: {
    id: 'AppsDirectory.AppDirNavHeader.PartnerLink',
    defaultMessage: 'Partner',
    description: '[Type: Link][Vis.: High] - A link that will direct the user to the partner form page',
  },
});

export const subdomainUri = (altdomain, domain, subdomain, tld) => {
  if (subdomain !== 'www') {
    return `https://${altdomain}.${subdomain}.${domain}.${tld}`;
  }
  return `https://${altdomain}.${domain}.${tld}`;
};

const navigationItems = ({ domain, subdomain, tld }) => [
  { target: '/apps', text: <T desc={COPY.NAV_EXPLORE} /> },
  {
    target: subdomainUri('developer', domain, subdomain, tld),
    text: <T desc={COPY.NAV_DEVELOP} />,
  },
  {
    target: 'https://www.surveymonkey.com/mp/partner-program/',
    text: <T desc={COPY.NAV_PARTNER} />,
  },
];

export function shouldDisplayNavItem(nav) {
  return !nav.requiresAuthentication;
}

const AppDirNavHeader = () => {
  const { environment } = useContext(StaticContext);
  const { userAgent } = useContext(StaticContext);
  const { isDesktop } = getClientEnvironmentDetails(userAgent);
  return (
    <>
      <DesktopScreen defaultMatches={isDesktop}>
        <div data-testid="AppDirNavHeader__Desktop">
          <AppDirNavHeaderDesktop navItems={navigationItems(environment)} />
        </div>
      </DesktopScreen>
      <MobileTabletScreen defaultMatches={!isDesktop}>
        <div data-testid="AppDirNavHeader__Mobile">
          <AppDirNavHeaderMobile navItems={navigationItems(environment)} />
        </div>
      </MobileTabletScreen>
    </>
  );
};

export default AppDirNavHeader;
